import type { NativeSelectOption } from '@/components/widget/WidgetNativeSelect.vue';

export function toOptions<T>(
  items: T[],
  getValue: (item: T) => string,
  getLabel: (item: T) => string,
): NativeSelectOption[] {
  return items.map((item) => ({ value: getValue(item), label: getLabel(item) }));
}
